import {requirePermission} from '@/modules/auth/permissions'
import {CustomerForm} from '@/modules/customers/components/customer-form/customer-form'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import * as z from 'zod'

const EditCustomerPageSchema = z.object({
  customerId: z.string().optional(),
})

export const Route = createFileRoute('/configuration/customers/new')({
  beforeLoad: requirePermission('organisation.manage'),
  component: NewCustomerContainer,
  validateSearch: EditCustomerPageSchema,
})

function NewCustomerContainer() {
  const {t} = useTranslate('common')

  const {customerId} = Route.useSearch()

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={customerId ? t('edit_customer_title') : t('new_customer_title')}
        description={t('new_customer_description')}
      />

      <CustomerForm customerId={customerId} />
    </NewResourceFormContainer>
  )
}
